import { useOrdersStore } from "../store";
import { useOrderActions } from "./useOrderActions";

export const useQuantity = (idItem?: string) => {
  const actions = useOrderActions();

  const qty = useOrdersStore(
    s => s.orders.find(o => o.cartItemId === idItem)?.quantity || 0
  );

  return { qty, ...actions };
};